import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { authSlice } from '@starjack/features/authentication';
import { stopRefresh } from '@/hooks/useAuthentication';

export const authMiddleware: Middleware = (api) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        const payload = action.payload as
            { status?: number; errors?: Array<{ error?: string }> } | undefined;
        if (payload?.status == 401) {
            stopRefresh();
            api.dispatch(
                authSlice.actions.clearAuthData({
                    userLogout: false,
                })
            );
            return;
        }
    }

    return next(action);
};
